<div class="overview">
  <div class="overview__grid">
    <section class="universe-card">
      <h2 class="section-title">
        {{ 'app.patrol.roblox.cockpit.config.overview.title' | translate }}
      </h2>
      <dl class="meta-list">
        <div class="meta-list__row">
          <dt>{{ 'app.patrol.roblox.cockpit.experiences.nameLabel' | translate }}</dt>
          <dd>{{ experience().displayName }}</dd>
        </div>
        @if (experience().communityId) {
          <div class="meta-list__row">
            <dt>{{ 'app.patrol.roblox.cockpit.experiences.universeId' | translate }}</dt>
            <dd><code>{{ experience().communityId }}</code></dd>
          </div>
        }
        <div class="meta-list__row">
          <dt>{{ 'app.patrol.roblox.cockpit.config.overview.status' | translate }}</dt>
          <dd>
            <span class="status-pill" [attr.data-status]="experience().status">
              {{
                'app.patrol.roblox.cockpit.status.' + experience().status | translate
              }}
            </span>
          </dd>
        </div>
        <div class="meta-list__row">
          <dt>{{ 'app.patrol.roblox.cockpit.config.overview.bridgeStatus' | translate }}</dt>
          <dd>
            <span
              class="bridge-pill"
              [attr.data-bridge-status]="experience().bridgeStatus ?? 'never_seen'"
            >
              {{
                'app.patrol.roblox.cockpit.bridgeStatus.' +
                  (experience().bridgeStatus ?? 'never_seen') | translate
              }}
            </span>
          </dd>
        </div>
        @if (experience().bridgeLastSeenAt) {
          <div class="meta-list__row">
            <dt>{{ 'app.patrol.roblox.cockpit.config.overview.bridgeLastSeen' | translate }}</dt>
            <dd>{{ formatDate(experience().bridgeLastSeenAt) }}</dd>
          </div>
        }
        @if (experience().linkedAt) {
          <div class="meta-list__row">
            <dt>{{ 'app.patrol.roblox.cockpit.config.overview.linkedAt' | translate }}</dt>
            <dd>{{ formatDate(experience().linkedAt) }}</dd>
          </div>
        }
        <div class="meta-list__row">
          <dt>{{ 'app.patrol.roblox.cockpit.config.overview.linkedMembers' | translate }}</dt>
          <dd>{{ experience().linkedMemberCount | number }}</dd>
        </div>
      </dl>
    </section>

    <app-patrol-roblox-ingest-panel [compact]="true" />
  </div>

  <section class="checklist-card">
    <h2 class="section-title">
      {{ 'app.patrol.roblox.cockpit.config.overview.checklistTitle' | translate }}
    </h2>
    <ul class="checklist">
      <li class="checklist__item">
        {{ 'app.patrol.roblox.cockpit.config.overview.checklist.registered' | translate }}
      </li>
      <li class="checklist__item">
        {{ 'app.patrol.roblox.cockpit.config.overview.checklist.allowlist' | translate }}
      </li>
      <li class="checklist__item">
        {{ 'app.patrol.roblox.cockpit.config.overview.checklist.studio' | translate }}
      </li>
      <li class="checklist__item">
        {{ 'app.patrol.roblox.cockpit.config.overview.checklist.publish' | translate }}
      </li>
    </ul>
  </section>
</div>
